import _defineProperty from "C:\\Projects\\@github\\@loopmode\\markdown\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import cx from 'classnames';
import React from 'react';
import { usePrism } from './hooks';
export function Codeblock(_a) {
  var _b;

  var className = _a.className,
      children = _a.children,
      _a$as = _a.as,
      Wrapper = _a$as === void 0 ? 'div' : _a$as,
      _a$theme = _a.theme,
      theme = _a$theme === void 0 ? 'okaidia' : _a$theme,
      innerProps = _a.innerProps,
      isContainer = _a.isContainer,
      providers = _a.providers,
      language = _a.language,
      parallel = _a.parallel,
      async = _a.async,
      onHighlight = _a.onHighlight,
      onHighlightError = _a.onHighlightError,
      props = __rest(_a, ["className", "children", "as", "theme", "innerProps", "isContainer", "providers", "language", "parallel", "async", "onHighlight", "onHighlightError"]);

  var elementRef = React.useRef(null);

  var _usePrism = usePrism(elementRef, {
    theme: theme,
    children: children,
    language: language,
    providers: providers,
    parallel: parallel,
    async: async,
    onHighlight: onHighlight,
    onHighlightError: onHighlightError
  }),
      languageClassName = _usePrism.languageClassName,
      themeClassName = _usePrism.themeClassName;

  return React.createElement(Wrapper, Object.assign({}, props, {
    ref: isContainer && elementRef,
    className: cx('Codeblock', className, themeClassName)
  }), isContainer ? children : React.createElement("pre", Object.assign({}, innerProps, {
    ref: elementRef,
    className: cx((_b = innerProps) === null || _b === void 0 ? void 0 : _b.className, _defineProperty({}, languageClassName, language))
  }), children));
}